define(function (require) {
    var $ = require("jquery");

    var cache = {};

    return {
        /**
         * Value indicating no geocoding results
         */
        noResults: "Geocode No Results",
        /**
         * Geocodes the given zip code or address into a latitude and longitude.
         * @param {} zipOrAddress
         * @returns {} jQuery promise which will return the lat/lng.
         */
        geocode: function (zipOrAddress) {
            var deferred = $.Deferred();

            // if we have no input just return a null result.
            if (!zipOrAddress) {
                deferred.resolve(null);
            }

            if (zipOrAddress) {
                if (cache.hasOwnProperty(zipOrAddress)) {
                    return cache[zipOrAddress];
                }

                if (!window.scan || !window.scan.googleMapsApiKey) {
                    throw new Error("window.scan.googleMapsApiKey is missing.");
                }

                var data = {
                    address: zipOrAddress,
                    key: window.scan.googleMapsApiKey
                };

                // when we encounter what looks like a ZIP Code, specify it as such to the Google API.
                // this will allow us to resolve some ZIP Codes that normally yield no results.
                if (/^\s*\d{5}([\-]\d{4})?\s*$/.test(zipOrAddress)) {
                    data.address += " zipcode";
                }

                $.ajax({
                    url: "https://maps.googleapis.com/maps/api/geocode/json",
                    data: data
                })
                    .done(function (data) {
                        if (data.results && data.results.length > 0 &&
                            data.results[0].geometry && data.results[0].geometry.location &&
                            data.results[0].address_components && data.results[0].address_components.length > 0) {
                            // find the county
                            var county = "";
                            $.each(data.results[0].address_components, function (index, addressComponent) {
                                $.each(addressComponent.types, function (innerIndex, addressComponentType) {
                                    if (addressComponentType == "administrative_area_level_2") {
                                        county = addressComponent.short_name;
                                    }
                                });
                            });
                            var result = {
                                lat: data.results[0].geometry.location.lat,
                                lng: data.results[0].geometry.location.lng,
                                county: county
                            };
                            console.log("geocode derived a lat of " + result.lat + " and a long of " + result.lng + " using zipcode of " + zipOrAddress);
                            // cache[zipOrAddress] = result;
                            deferred.resolve(result);
                        }

                        // if no results were located, return null.
                        deferred.resolve(null);
                    })
                    .fail(function () {
                        delete cache[zipOrAddress];
                        deferred.reject();
                    });
            }

            var promise = deferred.promise();

            cache[zipOrAddress] = promise;

            return promise;
        },
        /**
         * Geodecodes the given latitude and longitude into a zipcode
         * @param latitude
         * @param longitude
         * @returns jQuery promise which will return the zipcode
         */
        geodecode: function (latitude, longitude) {
            var deferredForReturningZipcode = $.Deferred();
            var result = {};
            var cacheKey = latitude + "," + longitude;
            var addressComponent;

            // if we have no input just return a null result.
            if (!latitude || !longitude) {
                deferred.resolve(null);
            }

            if (latitude && longitude) {
                if (!window.scan || !window.scan.googleMapsApiKey) {
                    throw new Error("window.scan.googleMapsApiKey is missing.");
                }
                $.ajax({
                    url: "https://maps.googleapis.com/maps/api/geocode/json",
                    data: {
                        latlng: cacheKey,
                        key: window.scan.googleMapsApiKey
                    }
                })
                    .done(function (data) {
                        if (data.results && data.results.length > 0 && data.results[0].address_components && data.results[0].address_components.length > 0) {
                            for (var i = 0; i < data.results[0].address_components.length; i++) {
                                addressComponent = data.results[0].address_components[i];

                                if (addressComponent && addressComponent.types && addressComponent.types.length > 0 && addressComponent.types.indexOf("postal_code") !== -1 && addressComponent.short_name) {
                                    result = { zipcode: addressComponent.short_name };
                                    console.log("geoDecode derived a zip of " + result.zipcode + " using geolocation in device of " + latitude + "," + longitude);
                                    deferredForReturningZipcode.resolve(result);
                                    break;
                                }
                            }
                        }

                        // if no results were located, return null.
                        deferredForReturningZipcode.resolve(null);
                    })
                    .fail(function () {
                        deferredForReturningZipcode.reject();
                    });
            }

            return deferredForReturningZipcode.promise();
        }
    };
});
